"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSf = void 0;
var getSf = function (n, forceInteger) {
    if (forceInteger === void 0) { forceInteger = false; }
    var nStr = "" + n;
    if (n <= 0) {
        return 0;
    }
    if (n > 0 && n < 1) { // 0.xxx
        if (forceInteger) {
            return Math.round(n);
        }
        var sf = nStr.split('').findIndex(function (it) { return it !== '0' && it !== '.'; });
        return Number(nStr.slice(0, sf + 1));
    }
    if (n >= 1) {
        return Number("" + nStr.slice(0, 1) + (Array.from(new Array(nStr.split('.')[0].length - 1))).map(function (it) { return '0'; }).join(''));
    }
    return 0;
};
exports.getSf = getSf;
